<template>
    <ai-grid-edit-wrapper
        ref='componentRef'
        :meta='meta'
        :args='args'
        :to-remove-toolbar-items-names='removeGridToolbarBtns'
        height="100%"
        :action="action"
        @toolbar-button-click="onToolbarClickGrid"
        @cell-click="onCellClick"
        @user-settings-changed="onUserSettingsChanged"
        @grid-focus-changed="onGridFocusChanged"
        @user-data-changed="onUserDataChanged"
        @refresh="onRefreshHandler"
        @dataLoaded="onDataLoadedHandler"
        @gridEditWrapperMounted="onGridEditWrapperMounted"
        @changesSavedSuccessfully="onChangesSavedSuccessfully"
        @changesRemoved="onChangesRemoved"
        @userDataChangedLoaded="onUserDataChangedLoaded"
        class="qs-tip-pruu-view"
    />
</template>
<script>
export default {
    name: 'qs-tip-pruu-view',
};
</script>
<script setup>
import { computed, ref } from 'vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import AiGridEditWrapper from '@/components/wrappers/ai-grid-edit-wrapper.vue';

const emit = defineEmits(['choose-nsi']);

const props = defineProps({
    action: {
        type: Object,
        default: () => {},
    },
    fromCard: {
        type: Boolean,
        default: () => false,
    }
});

const componentRef = ref(null);
const isNsiChoice = ref(false);
const selectedNsiKod = ref(null);

const args = computed(() => {
    return {
        select: {
            select_args: {
                is_not_active: props.fromCard
            }
        }
    }
});

const removeGridToolbarBtns = computed(() => {
    return  props.fromCard ? ['edit'] : ['choice', 'edit'];
});

const onCellClick = async (viewId, key) => {
    selectedNsiKod.value = key;
    if(selectedNsiKod.value && typeof selectedNsiKod.value === 'number') {
        await changeStatusChoiceButton(false);
    }
};

const onToolbarClickGrid = async (event) => {
    const  nameBtnclick = event?.item?.component?.name;
    if (nameBtnclick === 'choice') {
        isNsiChoice.value = true;
        await beforeNsiClose();
    }
    const btnArr = ['add', 'save', 'refresh', 'copy'];
    if(btnArr.includes(nameBtnclick)) {
        await changeStatusChoiceButton(true);
    }
};

const beforeNsiClose = (async () => {
    const canClose = await componentRef.value?.ref.checkBeforeClose();
    if (!canClose) return false;
    const dataGrid = await componentRef.value?.ref.getGridDataSource(500);
    const nsiChoiceItem = dataGrid.find(item => item['kod_tip_pruu'] === selectedNsiKod.value);
    emit('choose-nsi', nsiChoiceItem, isNsiChoice.value);

});

const clearData = (async () => {
    selectedNsiKod.value = null;
    await componentRef.value?.ref.setFocusdRow(null);
    await changeStatusChoiceButton(true);
    isNsiChoice.value = false;
});

const changeStatusChoiceButton = (async (status) => {
    const buttonsRefs = await componentRef.value?.ref.getButtonsRefs();
    buttonsRefs.value['isChoiceButtonDisabled'] = status;
});

const onChangesRemoved = () => {
    emit('changesRemoved');
};

const onDataLoadedHandler = () => {
    emit('dataLoaded');
};

const onChangesSavedSuccessfully = () => {
    emit('changesSavedSuccessfully');
};

const onUserDataChangedLoaded = userData => {
    emit('userDataChangedLoaded', userData);
};

const onGridEditWrapperMounted = async () => {
    setActiveViewInfo({
        refresh: componentRef.value.ref.setDataSource,
        userData: () => {},
        userSettings: () => {},
    });

    await setViewData();
    emit('gridEditWrapperMounted');
};
const onRefreshHandler = () => {
    emit('refresh');
};

const onUserDataChanged = args => {
    emit('userDataChanged', args);
};
const onGridFocusChanged = (row, viewId, rowIndex, component) => {
    emit('gridFocusChanged', row, viewId, rowIndex, component);
};
const onUserSettingsChanged = (settings, autoSaveMode) => {
    emit('userSettingsChanged', settings, autoSaveMode);
};

defineExpose({
    beforeNsiClose: beforeNsiClose,
    clearData: clearData,
    onDataLoadedHandler,
    onRefreshHandler,
    onUserDataChanged,
    onGridFocusChanged,
    onUserSettingsChanged,
    onGridEditWrapperMounted,
    onChangesSavedSuccessfully,
    onChangesRemoved,
    onUserDataChangedLoaded,
    componentRef,
    onToolbarClickGrid,
    onCellClick
});

const meta = {
    "keyExpr": "kod_tip_pruu",
    'selectionMode': props.fromCard ? 'single' : '',
    "columns": [
        {
            "name": "kod_tip_pruu",
            "caption": "Код",
            "dataField": "kod_tip_pruu",
            "allowEditing": false,
            "width": 150,
            "index": 1,
            "visible": false
        },
        {
            "name": "kod_r",
            "caption": "Вид СИ",
            "dataField": "kod_r",
            "allowEditing": true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_vid"
            },
            "component": {
                "name": "lookup-tip-pruu-kodr",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            },
            "width": 200,
            "index": 2,
            "visible": true
        },
        {
            "name": "obozn_t",
            "caption": "Обозначение СИ",
            "dataField": "obozn_t",
            "allowEditing": true,
            "width": 150,
            "index": 3,
            "visible": true
        },
        {
            "name": "name_uu",
            "caption": "Тип, марка",
            "dataField": "name_uu",
            "allowEditing": true,
            "width": 150,
            "index": 4,
            "visible": true
        },
        {
            "name": "work",
            "caption": "Завод изготов.",
            "dataField": "work",
            "allowEditing": true,
            "width": 150,
            "index": 5,
            "visible": true
        },
        {
            "name": "n_greest",
            "caption": "№ в Гос. реестре",
            "dataField": "n_greest",
            "allowEditing": true,
            "width": 150,
            "index": 6,
            "visible": true
        },
        {
            "name": "izm",
            "caption": "Принцип измерения",
            "dataField": "izm",
            "allowEditing": true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_izm"
            },
            "component": {
                "name": "lookup-tip-pruu-izm",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            },
            "width": 150,
            "index": 7,
            "visible": true
        },
        {
            "name": "mpi",
            "caption": "Межпов. интер",
            "dataField": "mpi",
            "allowEditing": true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_mpi"
            },
            "component": {
                "name": "lookup-tip-pruu-mpi",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            },
            "width": 150,
            "index": 8,
            "visible": true
        },
        {
            "name": "per_chas_arx",
            "caption": "Период час.архив. (сут.)",
            "dataField": "per_chas_arx",
            "allowEditing": true,
            "width": 150,
            "index": 9,
            "visible": true
        },
        {
            "name": "per_sut_arx",
            "caption": "Период сут.архив. (сут.)",
            "dataField": "per_sut_arx",
            "allowEditing": true,
            "width": 150,
            "index": 10,
            "visible": true
        },
        {
            "name": "kod_classif",
            "caption": "Классификация СИ",
            "dataField": "kod_classif",
            "allowEditing": true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_classif"
            },
            "component": {
                "name": "lookup-tip-pruu-classif-si",
                "id": "kod",
                "text": "name2",
                'minHeight': '200px'
            },
            "width": 250,
            "index": 11,
            "visible": true
        },
        {
            "name": "priznak_sovm",
            "caption": "Признак совмещенности",
            "dataField": "priznak_sovm",
            "allowEditing": true,
            "dataType": "boolean",
            "editor": {
                "type": "boolean",
            },
            "width": 250,
            "index": 12,
            "visible": true
        },
        {
            "name": "pr_active",
            "caption": "Активный/Архивный",
            "dataField": "pr_active",
            "allowEditing": true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_active"
            },
            "component": {
                "name": "lookup-tip-pruu-pr-active",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            },
            "width": 250,
            "index": 13,
            "visible": true
        }
    ],
    "api": {
        "select": "tep-nsi./tep-nsi/qs-tip-pruu/select/get",
        "save": "tep-nsi./tep-nsi/qs-tip-pruu/save/set"
    },
    "viewId": "qs-tip-pruu-view"
}
</script>

